import { EXECUTION_STATUS_CATEGORY, statusMapping } from "features/shared/lib/configs";
import { ExecutionStatus } from "features/shared/model/types";

import type { ProcessingJob } from "../model/types";

export const isTerminalJobStatus = (status: ExecutionStatus): boolean => {
  return EXECUTION_STATUS_CATEGORY[statusMapping[status]]?.isTerminal;
};

export const hasInProgressJobs = (jobs: undefined | { status: ExecutionStatus }[]): boolean => {
  if (!jobs?.length) return false;
  return jobs.some((job) => !isTerminalJobStatus(job.status));
};

export const toTrimmedDetailText = (value: unknown): string => {
  if (value == null) return "";
  if (typeof value === "string") return value.trim();
  if (typeof value === "number" || typeof value === "boolean") return String(value);
  if (Array.isArray(value)) {
    return value
      .map((item) => toTrimmedDetailText(item))
      .filter(Boolean)
      .join("\n");
  }
  if (typeof value === "object") {
    try {
      return JSON.stringify(value, null, 2);
    } catch {
      return "";
    }
  }
  return "";
};

export const processingJobHasDetails = (job: ProcessingJob): boolean => {
  return Boolean(toTrimmedDetailText(job.error_details) || toTrimmedDetailText(job.details?.summary));
};
